import loginBackground from 'portal-modules/tenant-portal-layout/images/login-background.jpg'

/**
 * Login background configuration for Tenant Portal
 * Optimized local assets for better performance
 */
/**
 * Get the login background image URL
 * @returns {string} Background image URL
 */
const getLoginBackgroundUrl = () => loginBackground

/**
 * Get complete login background configuration with modern CSS properties
 * @returns {Object} Background configuration
 */
const getLoginBackground = () => ({
  imageUrl: loginBackground,
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed', // Creates parallax effect
  // Modern CSS for better performance
  willChange: 'transform',
  backfaceVisibility: 'hidden',
})

/**
 * Get CSS background style string
 * @returns {string} CSS background property value
 */
const getLoginBackgroundStyle = () => {
  const config = getLoginBackground()
  return `url('${config.imageUrl}') ${config.backgroundPosition} / ${config.backgroundSize} ${config.backgroundRepeat} ${config.backgroundAttachment}`
}

// ES6 exports (consistent with import)
export {
  getLoginBackground,
  getLoginBackgroundUrl,
  getLoginBackgroundStyle
}

export default getLoginBackground